/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { LoadingPlaceholder } from '@g17eco/molecules/loader-container';
import { TrackingList, TrackingListProps } from '@g17eco/molecules/tracking-list';
import React, { Ref } from 'react';
import handleViewport from 'react-in-viewport';

interface ViewportInterface {
  inViewport: boolean;
  forwardedRef: Ref<HTMLDivElement>;
  enterCount: number;
  leaveCount: number;
  forceShow?: boolean;
}

const TrackingListWrapper = (props: TrackingListProps & ViewportInterface) => {
  const { forwardedRef, enterCount, forceShow } = props;

  const shouldShow = forceShow || enterCount > 0;

  if (!shouldShow) {
    return <div ref={forwardedRef}>
      <LoadingPlaceholder height={60} style={{ backgroundColor: 'white' }} />
    </div>;
  }

  return (
    <div ref={forwardedRef}>
      <TrackingList {...props} />
    </div>
  );
}


export const LazyLoadingTrackingList = handleViewport(TrackingListWrapper, /** options: {}, config: {} **/);
